import{Drawer as e}from"../../../node_modules/.pnpm/vaul@0.9.1_@types_react@18.3.12_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/vaul/dist/index.js";var a=e.Portal;export{a as default};
//# sourceMappingURL=SheetPortal.js.map
